<div class="panel d-flex">
  <div class="panel-content">
    <h2 class="mb-3 text-bold" i18n="@@fees.core.title">Lite | Buy, Sell and Swap Crypto</h2>
    <p class="text-md" i18n="@@fees.core.info">Instantly buy/sell {{ (currencies$ | async)?.length || 80 }}+ cryptocurrencies against AED{{displayFiatCurrencyPair[1]}} and swap between 200+ different cryptocurrency combinations at 0% fees.</p>
    <ng-container *ngTemplateOutlet="startButton"></ng-container>
  </div>
  <div class="p-2"></div>
  <badge-component class="col-lg-4 col-md-4 col-12"
    title="Trading Fee"
    content="0% - Zero Fees"
    i18n-title="@@fees.badge.core.title"
    i18n-content="@@fees.badge.core.content">
  </badge-component>
</div>
<div class="panel d-flex">
  <div class="panel-content w-100">
    <h2 class="mb-3 text-bold" i18n="@@fees.pro.title">Pro | Advanced Crypto Trading</h2>
    <p class="text-md" i18n="@@fees.pro.info1">{{ (currencies$ | async)?.length || 80 }}+ cryptocurrencies and 200+ trading pairs against fiat and other cryptocurrencies. Trade smoothly in real-time with our sophisticated trading charts and comprehensive order types. Order execution is seamless with our highly-liquid orderbooks.</p>
    <p class="text-md" i18n="@@fees.pro.info2">BitOasis Pro follows the <strong>maker-taker fee</strong> model which rewards high-volume trading; The more you trade, the lower your fees become as shown below.</p>
    <div class="panel soft mt-4 mb-4">
      <h4 class="text-md text-bold" i18n="@@fees.pro.maker.title">Makers Fee:</h4>
      <p class="text-md" i18n="@@fees.maker.info">Makers pay fees when placing either a limit buy or sell order that isn't carried out immediately. These orders are based on the price movement and they’re called “makers” because you add to the orderbook, thus “making” liquidity.</p>
      <h4 class="text-md text-bold" i18n="@@fees.pro.taker.title">Taker Fee:</h4>
      <p class="text-md" i18n="@@fees.taker.info">As opposed to Makers, Market Takers immediately take volume off of the order book by placing a direct market order. The more you trade on the exchange, the less you pay in both maker and taker fees.</p>
    </div>
    <div class="text-center">
      <fees-table
        title="Crypto-Crypto and Crypto-Stablecoins Pairs"
        info="Below fees apply to all crypto to crypto pairs (E.g. BTC-USDT, ETH-USDC, BTC-ETH, LTC-XRP)"
        i18n-title="@@fees.crypto.fiat.title"
        i18n-info="@@fees.crypto.fiat.info"
        [data]="digitalFee"
        *ngIf="digitalFee.fee || fiatDigitalFee.discountedFee"
      ></fees-table>
      <div i18n="@@fees.pro.fiat.info">Below fees apply to all pairs with fiat currencies such as AED{{displayFiatCurrencyPair[2]}} and others (E.g. BTC-AED, ETH{{displayFiatCurrencyPair[0]}})</div>
      <fees-table
        title="Crypto-Fiat Pairs"
        info="Below fees apply to all pairs with fiat currencies such as AED{{displayFiatCurrencyPair[2]}} and others (E.g. BTC-AED, ETH{{displayFiatCurrencyPair[0]}})"
        i18n-title="@@fees.pro.fiat.title"
        i18n-info="@@fees.pro.fiat.info"
        [data]="fiatDigitalFee"
        *ngIf="fiatDigitalFee.fee || fiatDigitalFee.discountedFee"
      ></fees-table>
      <fees-table
        title="USDT-AED Pair"
        info="Below fees apply to USDT-AED pair"
        i18n-title="@@fees.pro.aedusdt.title"
        i18n-info="@@fees.pro.aedusdt.info"
        [data]="aedUsdtFee"
        *ngIf="aedUsdtFee.fee || aedUsdtFee.discountedFee"
      ></fees-table>
    </div>
  </div>
</div>
